import { type DependencyList, useCallback, useLayoutEffect } from 'react'

import { createInterval } from '../../../utils'

/**
 * @warning keep deps here
 */
const fallbackDeps: DependencyList = []

/**
 * Sets up a useEffect that is also hooked to a timed (by setInterval rules) re-render
 *
 * @param interval
 *  In milliseconds, needs to be less than 32-bit integer
 *  @see https://developer.mozilla.org/en-US/docs/Web/API/setInterval#sect1
 */
export const useIntervalEffect = (callback: VoidFunction, interval: number, deps: DependencyList = fallbackDeps): void => {
    /** Ensure no closure mishaps occur */
    const cachedCallback = useCallback(callback, deps)

    /** Sets up timed-updater */
    useLayoutEffect(() => {
        /** First ensure that the time is up an running */
        const off = createInterval(cachedCallback, interval)

        /** Make the initial call */
        cachedCallback()

        /** And give the unhook function to the use effect hook to do its thing */
        return off
    }, [interval, cachedCallback])
}
